import Header from './components/Header';
import Hero from './components/Hero';
import {
  IndexSection,
  ContactSection,
  UpdatesSection,
  CommentsSection,
  RankingSection,
  MediaSection,
  AppSection,
} from './components/ContentSectionsA';
import {
  FeaturesSection,
  AboutSection,
  FaqSection,
  CarouselSection,
  TopicsSection,
  CardsSection,
} from './components/ContentSectionsB';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <ContactSection />
        <UpdatesSection />
        <CommentsSection />
        <RankingSection />
        <MediaSection />
        <AppSection />
        <FeaturesSection />
        <AboutSection />
        <FaqSection />
        <CarouselSection />
        <TopicsSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}